import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import adminService from '../../services/adminService';
import { OptionValue } from '../../services/types/Misc';
import { User } from '../../services/types/User';
import { AutocompleteChips, Modal, SpinnerArea } from '../../shared/components';
import MainContext from '../App/MainProvider/context';

interface Member {
  email: string;
  fullName: string;
}

interface Props {
  visible: boolean;
  // setVisible: (value: React.SetStateAction<boolean>) => void;
  setVisible: (value: boolean) => void;
  onSelect: (member: Member | null | undefined) => void;
  activeTab: string;
}

const AddMemberPopup: React.FC<Props> = (props) => {
  const { visible, setVisible, onSelect, activeTab } = props;
  const { service } = useContext(MainContext);
  const [data, setData] = useState<User[] | null>(null);
  const [filteredData, setFilteredData] = useState<OptionValue[]>([]);
  const [loading, setLoading] = useState(false);
  const [memberSelected, setMemberSelected] = useState<OptionValue | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (visible) {
      service(() => adminService.getUsersForAdd(), {
        callback: (members) => {
          setData(members);
          setFilteredData(
            members.map((x) => ({ text: x.fullName, value: x.email } as OptionValue))
          );
        },
        loader: setLoading,
      });
    }
  }, [visible]);

  const handleMembersSearch = (query: string) => {
    if (data) {
      const list = data.filter((x) => x.fullName.toUpperCase().includes(query.toUpperCase()));
      setFilteredData(list.map((x) => ({ text: x.fullName, value: x.email } as OptionValue)));
    }
  };

  return (
    <Modal
      title={activeTab === '1' ? t('addESGMember') : t('addGPMember')}
      visible={visible}
      setVisible={() => setVisible(false)}
      actions={[
        { text: 'Close', action: () => setVisible(false), className: 'btn-tertiary' },
        {
          text: activeTab === '1' ? t('addESGMember') : t('addGPMember'),
          action: () =>
            onSelect(
              memberSelected
                ? ({ email: memberSelected.value, fullName: memberSelected.text } as Member)
                : null
            ),
          className: 'btn-primary',
        },
      ]}
    >
      <SpinnerArea loading={loading}>
        {data && (
          <div className="p-3">
            <AutocompleteChips<OptionValue>
              text={`${t('enterMembersName')}:`}
              labelKey="text"
              htmlId="egs-members-typeahead"
              list={filteredData}
              placeholder=""
              onSearch={handleMembersSearch}
              onChange={(value) => setMemberSelected(value[0])}
              loading={loading}
              render={(option: OptionValue) => <div key={option.value}>{option.text}</div>}
              className="label_autocomplete"
            />
          </div>
        )}
      </SpinnerArea>
    </Modal>
  );
};

export default AddMemberPopup;
